﻿import { defineComponent } from 'vue';

import header_menu from "../header/menu.vue"
import footer_item from "../base/common/footer.vue"

import add_ons from "../base/3_cart/add-ons.vue"
import tours from "../base/3_cart/tours.vue"
import basket from "../base/common/basket.vue"
import basket_header from "../base/common/header.vue"
import trip_summary from "../base/3_cart/summary.vue"

import { Booking } from "../../services/booking";
import { Web_Engine } from "../../services/web_engine";

import { booking_group } from "../../objects/v1_2/Booking/Booking_Group"
import { booking_search_group } from "../../objects/v1_2/Booking_Details/booking_search_group"

const Book = new Booking();
const Web_Engines = new Web_Engine();

export default defineComponent({
    components: {
        footer_item,
        header_menu,
        add_ons,
        tours,
        basket,
        basket_header,
        trip_summary
    },
    methods: {
        async Get_Quote() {
            if (Web_Engines.getSession_ID() + "" == "" || (this.$store.getters.get_Booking_Login?.booking_info?.iso_currency_code + "" != "" && this.$store.getters.get_Booking_Login?.booking_info?.booking_identifier + "" == "")) {
                this.$store.commit("Setup_Booking", { Booking_Details: await Book.Quote_Booking(this.$store) });
            }
            else {
                await Book.Get_Session_Information(Web_Engines.getSession_ID()).then(async (User_Info) => {
                    this.$store.commit("Set_Booking_Login", { Booking_Login: User_Info });
                    await Web_Engines.Initialise_Currency(this.$store, User_Info.booking_info.iso_currency_code);

                    await Book.Download_Booking(User_Info.booking_info.booking_identifier).then(async (Booking_Details) => {
                        this.$store.commit("Initialise_Basket_AddOns", { Currency: User_Info.booking_info.iso_currency_code, Booking_Details: Booking_Details });
                        this.$store.commit("Setup_Booking", { Booking_Details: Booking_Details });
                    });
                });
            }
        },
        get_Basket(): booking_group {
            return this.$store.getters.get_Basket;
        },
        remove_Excluded_Trips() {
            let basket = this.get_Basket();
            basket.trips.forEach(trip => {
                if (import.meta.env.VITE_EXCLUDED_TOURS?.includes(trip.tour_id)) {
                    this.$store.commit("Remove_Product", { Tour_ID: trip.tour_id });
                }
            });
        },
        total_tours(): string {
            if (this.$store.getters.get_Basket.trips.length == 1) {
                return "1 Tour";
            }

            return this.$store.getters.get_Basket.trips.length + " Tours";
        },
        header_text(): string {
            return "You have <strong>" + this.total_tours() + "</strong> and <strong>" + this.total_add_ons() + "</strong > in your basket.";
        },        
        total_add_ons(): string {
            let Add_Ons: number = Book.getTotal_Add_Ons(this.$store.getters.get_Basket);

            if (Add_Ons == 0) {
                return "no add-ons";
            }

            if (Add_Ons == 1) {
                return "1 add-on";
            }

            return Add_Ons + " add-ons";
        },
        scrollBehavior() {
            window.scrollTo(0, 0)
        },
        isInternal_Booking_Engine(): boolean {
            return Web_Engines.getSession_ID() + "" != "";
        },
        cartEmpty(){
            let returnvalue = false;
            let basket = this.get_Basket();

            if(basket.passengers.toString() === null || basket.passengers.toString() === undefined || basket.passengers.toString() === ''){
                returnvalue = true;
            }
            
            if (basket.trips.length === 0 || basket.trips[0].departure_date == null || basket.trips[0].departure_date == undefined || basket.trips[0].departure_date == '') {
                returnvalue = true;
            }

            return returnvalue;
        },
        async Remove_Trip(tour_id: string) {
            this.$store.commit("Remove_Product", { Tour_ID: tour_id });
            if (this.$store.getters.get_Basket?.trips[0]?.tour_id == "" || this.$store.getters.get_Basket.trips.length == 0) {
                this.$router.push("/");
            } else {
                this.$store.commit("Setup_Booking", { Booking_Details: await Book.Quote_Booking(this.$store) });
                this.$router.push({ path: "/cart", hash: "#add_on_" + tour_id });
            }
        },
        RemoveInvalidTours()
        {
            this.$store.getters.get_Basket.trips.forEach((trip: any) => {
                if(trip.departure_date == null || trip.departure_date == undefined || trip.departure_date == "")
                {
                    this.Remove_Trip(trip.tour_id);
                }
                else if(trip.passengers.length < 0)
                {
                    this.Remove_Trip(trip.tour_id);
                }
            });
        }
    },
    mounted() {
        this.Get_Quote();
        this.remove_Excluded_Trips();
        this.RemoveInvalidTours();
    }
})